<template>
     <v-card v-if="company.oauth_settings" class="mt-3">
        <v-card-title class="grey lighten-4 pa-2">
            <h3 class="secondary--text">{{$t('company.page.setting.section.oauth_settings')}}</h3>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="$emit('onSave')" small>Save</v-btn>
        </v-card-title>
        <v-card-text>
            <v-layout  row wrap class="pt-2">
            <v-flex xs12 sm6 md6>
              <!-- Theme -->
              <v-flex xs12 class="px-3">
                <v-switch
                  v-model="company.oauth_settings.enabled"
                  :label="$t('company.page.oauth.settings.enabled')"
                  color="primary"
                  @change="$emit('onGenerateNewOAuthSecret')"
                ></v-switch>
                <v-divider></v-divider>
              </v-flex>
            </v-flex>
            </v-layout>
        </v-card-text>
        <v-card-text>
                <!-- OAuth configuration -->
                  <v-flex xs12 class="px-3">
                    <v-layout row wrap>
                      <v-flex xs11 md11>
                        <v-text-field
                          v-model="company.oauth_settings.secret"
                          color="primary"
                          disabled
                          :label="$t('company.page.oauth.settings.label.oauth_secret')"
                          @input="$emit('getMailchimpLists',company)"
                          @click:append-outer="copySecret()"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs1 md1>
                        <v-btn
                        color="success"
                        fab
                        dark
                        small
                        @click="copySecret()"
                        ><v-icon small
                          >$vuetify.icons.rms_copy</v-icon
                        ></v-btn>
                      </v-flex>
                    </v-layout>

                  </v-flex>
                  <v-flex xs12 class="px-3">
                    <v-combobox
                      v-model="company.oauth_settings.allowed_domains"
                      :items="company.oauth_settings.allowed_domains"
                      :search-input.sync="search"
                      hide-selected
                      :hint="$t('company.page.oauth.settings.label.allowed_domains.subtitle')"
                      :label="$t('company.page.oauth.settings.label.allowed_domains')"
                      multiple
                      persistent-hint
                      small-chips
                    >
                      <template v-slot:no-data>
                        <v-list-tile>
                          <v-list-tile-content>
                            <v-list-tile-title>
                              No domain matching "<strong>{{ search }}</strong>". Press <kbd>enter</kbd> to add a new one
                            </v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </template>
                    </v-combobox>
                  </v-flex>
            </v-card-text>
    </v-card>
</template>
<script>
export default {
    name: "OAuthSettings",
    props: {
        company: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            oauth_defaut_settings: {
                enabled: false,
                expire_at: null,
                allowed_domains: [],
                secret: null
            },
            search: null
        }
    },
    mounted() {
      this.initialiseOAuthSettings()
    },
    methods: {
      initialiseOAuthSettings() {
        if(!this.company.oauth_settings){
          this.company.oauth_settings = this.oauth_defaut_settings
        }
      },

      async copySecret() {
      this.$copyText(this.company.oauth_settings.secret);
      this.$store.dispatch("app/showMessage", {
        message: "Secret copied successfully",
        color: this.DEFINES.SNACKBAR_SUCCESS_COLOR,
      });
    },
    }
}
</script>
